import React, { useContext } from "react";
import BannerImage from "./BannerImage";
import BannerVideo from "./BannerVideo";
import {api} from "../../../api/api"
import HotspotContext from "../../../context/HotspotContext";

const Banner = ({value, timer, setTimer, nextFunc, adSuccess, skipTimerRef}) => {
    const {request} = useContext(HotspotContext)
    const setForceRedirect = () => request.force = value.redirect_url

    const detailButtonEvent = () => {
        api.promoEvent(value.id, "next")
        clearTimeout(skipTimerRef.current)
        skipTimerRef.current = null
        setForceRedirect()
        adSuccess()
    }
    const skipButtonEvent = () => {
        api.promoEvent(value.id, "skip")
        clearTimeout(skipTimerRef.current)
        skipTimerRef.current = null
        nextFunc()
    }
    const timeoutEvent = () => {
        api.promoEvent(value.id, "timeout")
        clearTimeout(skipTimerRef.current)
        skipTimerRef.current = null
        nextFunc()
    }
 
    return (
        <>
            {
                value.type === "image"
                    ? <BannerImage
                        value={value}
                        timer={timer}
                        setTimer={setTimer}
                        timeoutHandler={timeoutEvent}
                        nextFunc={skipButtonEvent}
                        detailHandler={detailButtonEvent}
                    />
                    : <BannerVideo
                        value={value}
                        timer={timer}
                        setTimer={setTimer}
                        timeoutHandler={timeoutEvent}
                        nextFunc={skipButtonEvent}
                        detailHandler={detailButtonEvent}
                    />
            }
        </>
    )
}

export default Banner